import { render, staticRenderFns } from "./CollaborationAccountIndex.vue?vue&type=template&id=749e770c&"
import script from "./CollaborationAccountIndex.vue?vue&type=script&lang=js&"
export * from "./CollaborationAccountIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports